import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "d-flex align-items-center shorteval-wrapper w-100" }
const _hoisted_4 = ["for", "aria-hidden"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "icon icon-tick",
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "10",
  viewBox: "0 0 15 10",
  fill: "none"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.52468 9.58534C4.52819 9.58895 4.53174 9.59255 4.53531 9.59612C4.65814 9.71895 4.80498 9.80315 4.96072 9.84871C5.30018 9.94812 5.682 9.86394 5.94975 9.59619C5.95457 9.59137 5.95933 9.58651 5.96403 9.58162L13.7277 1.81795C14.1182 1.42742 14.1182 0.794257 13.7277 0.403733C13.3372 0.0132088 12.704 0.0132088 12.3135 0.403733L5.2425 7.47472L1.70711 3.93933C1.31658 3.54881 0.683417 3.54881 0.292893 3.93933C-0.0976311 4.32986 -0.0976311 4.96302 0.292893 5.35355L4.52468 9.58534Z",
  fill: "#44BE0A"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_WarnTriangleFilled = _resolveComponent("WarnTriangleFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['shorteval-date-component mb-5', _ctx.showElement ? '' : 'd-none']),
    id: `element-${_ctx.name}`
  }, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          innerHTML: _ctx.title
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(['d-flex align-items-center mt-1', _ctx.classDiv])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", {
          for: _ctx.id,
          "aria-hidden": !_ctx.canShowLabel,
          class: _normalizeClass(['el-form-item__label', _ctx.isFloatingLabel ? 'floating-label' : '', _ctx.canShowLabel ? '' : 'd-none'])
        }, _toDisplayString(_ctx.placeholder), 11, _hoisted_4),
        _createVNode(_component_el_config_provider, { locale: _ctx.locale }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: _ctx.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
              id: _ctx.id,
              name: _ctx.name,
              type: _ctx.type,
              "range-separator": _ctx.rangeSeparator,
              placeholder: _ctx.title ? _ctx.placeholder : '',
              "start-placeholder": _ctx.startPlaceholder,
              "end-placeholder": _ctx.endPlaceholder,
              size: _ctx.size,
              clearable: false,
              format: _ctx.format,
              class: _normalizeClass([
              'preffix-icon',
              _ctx.showError ? 'text-danger errorElement' : '',
              _ctx.isTouched ? 'me-1 me-lg-3' : 'me-1 me-lg-3',
              _ctx.classInput
            ]),
              "prefix-icon": _ctx.instance.root.components.CalendarIcon,
              "popper-class": _ctx.popperClass,
              "disabled-date": _ctx.disabledDate,
              "value-format": _ctx.valueFormat,
              onChange: _ctx.updateValue,
              onKeydown: _ctx.onKeyDown,
              onFocus: _ctx.setFloatingLabel,
              onBlur: _ctx.onBlur,
              onPanelChange: _ctx.onPanelChange
            }, null, 8, ["modelValue", "id", "name", "type", "range-separator", "placeholder", "start-placeholder", "end-placeholder", "size", "format", "class", "prefix-icon", "popper-class", "disabled-date", "value-format", "onChange", "onKeydown", "onFocus", "onBlur", "onPanelChange"])
          ]),
          _: 1
        }, 8, ["locale"])
      ]),
      (_ctx.icons.clearIcon && _ctx.clearable && _ctx.isTouched)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetValues && _ctx.resetValues(...args))),
            src: _ctx.icons.clearIcon,
            alt: 'Clear icon',
            class: "el-select-clear-icon img-fluid"
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.isTouched || _ctx.showError)
        ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 1,
            class: "ms-1",
            style: {"vertical-align":"middle"},
            size: 20,
            color: `${_ctx.showError ? '#DE0D26' : '#44BE0A'}`
          }, {
            default: _withCtx(() => [
              (_ctx.isValid)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8))
                : _createCommentVNode("", true),
              (!_ctx.isValid || _ctx.showError)
                ? (_openBlock(), _createBlock(_component_WarnTriangleFilled, { key: 1 }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["color"]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.showError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
          _createElementVNode("small", null, _toDisplayString(_ctx.errorMessage), 1)
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}